"use strict";
// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/message/v1/portal_service.proto (package spwn.message.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortalMessageService = void 0;
const portal_service_pb_1 = require("./portal_service_pb");
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from service spwn.message.v1.PortalMessageService
 */
exports.PortalMessageService = {
    typeName: "spwn.message.v1.PortalMessageService",
    methods: {
        /**
         * DMを投稿
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.PostDMMessage
         */
        postDMMessage: {
            name: "PostDMMessage",
            I: portal_service_pb_1.PortalMessageServicePostDMMessageRequest,
            O: portal_service_pb_1.PortalMessageServicePostDMMessageResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * DMを削除する
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.DeleteDMMessage
         */
        deleteDMMessage: {
            name: "DeleteDMMessage",
            I: portal_service_pb_1.PortalMessageServiceDeleteDMMessageRequest,
            O: portal_service_pb_1.PortalMessageServiceDeleteDMMessageResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 選択された既存のスレッドをgetする
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetDMThread
         */
        getDMThread: {
            name: "GetDMThread",
            I: portal_service_pb_1.PortalMessageServiceGetDMThreadRequest,
            O: portal_service_pb_1.PortalMessageServiceGetDMThreadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * 既存のスレッド一覧をgetする
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetDMUnselectedThreadList
         */
        getDMUnselectedThreadList: {
            name: "GetDMUnselectedThreadList",
            I: portal_service_pb_1.PortalMessageServiceGetDMUnselectedThreadListRequest,
            O: portal_service_pb_1.PortalMessageServiceGetDMUnselectedThreadListResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * DMのやり取りをしたことないクリエイターとファンがDMのやり取りを行う権限があるかを確認
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetNewDMThread
         */
        getNewDMThread: {
            name: "GetNewDMThread",
            I: portal_service_pb_1.PortalMessageServiceGetNewDMThreadRequest,
            O: portal_service_pb_1.PortalMessageServiceGetNewDMThreadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * S3へのファイルアップロード用のpresigned urlをgetする
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetSignedUrlForFileUpload
         */
        getSignedUrlForFileUpload: {
            name: "GetSignedUrlForFileUpload",
            I: portal_service_pb_1.PortalMessageServiceGetSignedUrlForFileUploadRequest,
            O: portal_service_pb_1.PortalMessageServiceGetSignedUrlForFileUploadResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * ユーザーが受信したDMメッセージの中に未読のものがあるか
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetUnreadMessageExistsStatus
         */
        getUnreadMessageExistsStatus: {
            name: "GetUnreadMessageExistsStatus",
            I: portal_service_pb_1.PortalMessageServiceGetUnreadMessageExistsStatusRequest,
            O: portal_service_pb_1.PortalMessageServiceGetUnreadMessageExistsStatusResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * メッセージを受け取った時に、メール通知を受け取る設定を変更
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.UpdateUserDmNotificationSetting
         */
        updateUserDmNotificationSetting: {
            name: "UpdateUserDmNotificationSetting",
            I: portal_service_pb_1.PortalMessageServiceUpdateUserDmNotificationSettingRequest,
            O: portal_service_pb_1.PortalMessageServiceUpdateUserDmNotificationSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
        /**
         * メッセージを受け取った時に、メール通知を受け取る設定を取得
         *
         * @generated from rpc spwn.message.v1.PortalMessageService.GetUserDmNotificationSetting
         */
        getUserDmNotificationSetting: {
            name: "GetUserDmNotificationSetting",
            I: portal_service_pb_1.PortalMessageServiceGetUserDmNotificationSettingRequest,
            O: portal_service_pb_1.PortalMessageServiceGetUserDmNotificationSettingResponse,
            kind: protobuf_1.MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=portal_service_connect.js.map